import Vue from 'vue'
import router from '../../router'
export default {
  getBrokerInformation ({ commit }) {
    return Vue.axios.get(`/about/broker-information`)
    .then(({ data }) => commit('ADD_BROKER_INFORMATION', data))
  },
  getBrokerInformationById ({ commit }, id) {
    return Vue.axios.get(`/about/broker-information/${id}`)
    .then(({ data }) => commit('ADD_BROKER_INFORMATION', data))
  },
  addBrokerInformation ({ commit }, data) {
    return Vue.axios.post(`/about/broker-information`, { data })
    .then(({ data }) => {
      commit('ADD_NEW_BROKER_INFORMATION', data)
      commit('ADD_BROKER_INFORMATION', data)
      router.push({ name: 'BrokerInformation' })
    })
  },
  deleteBrokerInformation ({ commit }, id) {
    return Vue.axios.delete(`/about/broker-information/${id}`)
    .then(() => {
      commit('DELETE_BROKER_INFORMATION', id)
      router.push({ name: 'BrokerInformation' })
    })
  },
  updateBrokerInformation ({ commit }, data) {
    return Vue.axios.put(`/about/broker-information`, { data })
    .then(() => router.push({ name: 'BrokerInformation' }))
  }
}



// WEBPACK FOOTER //
// ./src/store/actions/brokerInformation.js